
import { NEXT_MOVE_ASSESSMENT_STATE } from "@/store/modules/my_next_move/constants";
import { MyNextMoveAssessmentStates } from "@/store/modules/my_next_move/interfaces";
import { get_portal_formatted_name } from "@/utils/global";
import Vue from "vue";
import { mapMutations } from "vuex";
export default Vue.extend({
  name: "NextMoveStart",
  data() {
    return {
      title: "Welcome to the HCMS Interest Profiler!"
    };
  },
  created() {
    this.title = `Welcome to the ${get_portal_formatted_name()} Interest Profiler!`;
  },
  methods: {
    get_portal_formatted_name,
    ...mapMutations("my_next_move", {
      update_next_move_assessment_state: NEXT_MOVE_ASSESSMENT_STATE
    }),
    update_state() {
      this.update_next_move_assessment_state(
        MyNextMoveAssessmentStates.INTERESTS_SCORES
      );
    }
  }
});
